const { alert } = require('site/components/alerts');
const recaptcha = require('google_recaptcha/components/recaptcha');

module.exports = {
    submit: () => {
        const $form = $('.js-submit-customer-service');

        $form.on('submit', (e) => {
            const submitForm = (token) => {
                if (token) {
                    $('input[name=g-recaptcha-response]').val(token);
                }
                const url = $form.attr('action');
                $form.spinner().start();
                const errorMsg = { message: 'For technical reasons, your request could not be handled properly at this time. We apologize for any inconvenience.' };

                $.ajax({
                    url,
                    type: 'POST',
                    dataType: 'json',
                    data: $form.serialize(),
                    success: (data) => {
                        $form.spinner().stop();
                        if (data.success) {
                            const $success = $('.js-customer-service-success');
                            const successMsg = $success.html().replace(/\{0\}/g, document.getElementById('email').value);

                            $success.html(successMsg).removeClass('d-none');
                            $form.hide();
                            $form[0].reset();
                        } else {
                            alert({ message: data.error });
                        }
                    },
                    error: () => {
                        $form.spinner().stop();
                        alert(errorMsg);
                    },
                });
                return false;
            };
            const recaptchaKey = $('.js-recaptcha').data('sitekey');

            e.preventDefault();

            if (recaptchaKey) {
                window.grecaptcha.ready(() => {
                    window.grecaptcha.execute(recaptchaKey, { action: 'submit' }).then((token) => {
                        submitForm(token);
                    });
                });
            } else {
                submitForm();
            }
        });
    },
    recaptchaInit: recaptcha.init,

};
